import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import logo from "src/assets/icons/app_logo.png";
import whitelogo from "src/assets/icons/white-logo.png";
import fav from "src/assets/icons/small-logo.png";
import whiteFav from "src/assets/icons/white-fav.png";
import FIcon from "src/assets/icons/f-icon.png";
import { useHistory } from 'react-router-dom';
import {
  CHeaderNavItem,
  CHeaderNavLink,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CDropdown,
  CModal,
  CModalBody,
} from "@coreui/react";
// import CIcon from "@coreui/icons-react";
import Tooltip from '@material-ui/core/Tooltip';
import cookie from 'react-cookies'
// routes config

import {
  TheHeaderDropdown,
} from "./index";

import { GSTIN_CHANGE_UPDATE } from 'src/action-type/gst-authentication';
import { CLEAR_AFER_LOGIN, RESET_SOCIAL_AUTH_DATA } from "src/actions/actionTypes";

const TheHeader = () => {
  const theme = useSelector(state => state.userReduser?.selectedTheme)
  const selectedGstnList = useSelector(state => state.userReduser?.selectedGstnList)
  const dispatch = useDispatch();
  const history = useHistory();

  const sidebarShow = useSelector((state) => state?.changeState.sidebarShow);
  const [dropDownValue, setdropDownValue] = useState("")
  const [showPopUp, setShowpopUp] = useState()
  const [pathType, setPathType] = useState("")

  const userDetailsData = useSelector(state => state.GstAuthReducer.userDetailsData);
  const yearsList = useSelector((state) => state.gstr2aReducer.yearsList);

  useEffect(() => {
    dispatch({ type: RESET_SOCIAL_AUTH_DATA, payload: [] });
  }, [])
  const onDropDownChange = (value) => {
    setdropDownValue(value);
    cookie.save('SELECTED_GSTIN_DETAIL', value, { path: '/' });
    dispatch({ type: "CHANGE_YEAR_RANGE", payload: yearsList.current_year })
    history.push("/dashboard")


    dispatch({ type: GSTIN_CHANGE_UPDATE, payload: value.gstin });

  }

  //switch modal
  const [primaryRefModal, setprimaryRefModal] = useState(false)
  const onRefModalClose = () => {
    setprimaryRefModal(false)
  }

  const redirectToGST = () => {
    onRefModalClose()
    window.open("https://app.finsights.biz/#/login", "_blank")
  }

  useEffect(() => {

    if (userDetailsData.length > 0 && !(cookie.load('SELECTED_GSTIN_DETAIL'))) {
      setdropDownValue(userDetailsData[0]);
      cookie.save('SELECTED_GSTIN_DETAIL', userDetailsData[0], { path: '/' });
      dispatch({ type: GSTIN_CHANGE_UPDATE, payload: userDetailsData[0].gstin });

    }
  }, [userDetailsData]);

  useEffect(() => {
    dispatch({ type: CLEAR_AFER_LOGIN, payload: [] });
  }, [dispatch]);
  return (
    <>

      {/* {(showPopUp == "notifications") && <Notifications popup={true} pathType={pathType}></Notifications>}
      <CHeader withSubheader>
        <CToggler
          inHeader
          className="ml-md-3 d-lg-none"
          onClick={toggleSidebarMobile}
        />
        <CToggler
          inHeader
          className="ml-4 d-none"
          onClick={toggleSidebar}
        />
        <CHeaderBrand className="ml-3 mr-aut d-lg-none" to="/">
          <img src={logo} className="c-sidebar-brand-full" />{" "}
        </CHeaderBrand>
        <CHeaderNav className="d-md-down-none mr-aut col- ml-4">
          <CSidebarBrand className="d-md-down-none" to="/">
            <img src={logo} className="c-sidebar-brand-full" width="" />{" "}
            <img src={fav} className="c-sidebar-brand-minimized" width="45" />
          </CSidebarBrand>
        </CHeaderNav>
        <CHeaderNav className="d-md-down-none mr-auto col-2 ml-4">
          <CHeaderNavItem className="px-3 company-bg-background top-header-dropdown-menu">
            <div>
              <CDropdown className="mt-0">
                <CDropdownToggle caret={false} color="link btn-sm text-dark bold-label" style={{ fontSize: "10px", boxShadow: 'none', lineHeight: '1.4', textDecoration: 'none', paddingLeft: 0, fontWeight: "600", textTransform: "capitalize" }}>
                  <Tooltip title="Change GSTIN" placement={'right-end'} arrow>
                    <div>
                      <div className="main-company">{cookie.load("SELECTED_GSTIN_DETAIL") ? <>{cookie.load("SELECTED_GSTIN_DETAIL").gstin} - {cookie.load("SELECTED_GSTIN_DETAIL").legal_name}</> : <>{dropDownValue.gstin} - {dropDownValue.legal_name}</>}</div>
                      <i className="fas fa-chevron-circle-down min-font-size ml-2"></i>
                    </div>
                  </Tooltip>
                </CDropdownToggle>


                {cookie.load('SELECTED_GSTIN_LIST') !== undefined && <CDropdownMenu className="border-0 mdb-shadow small-font-dropdown slideIn animate-dropdown" >
                  {cookie.load('SELECTED_GSTIN_LIST').length > 0 && cookie.load('SELECTED_GSTIN_LIST').map((data, i) => {
                    return (<CDropdownItem key={i} onClick={(e) => onDropDownChange(data)}>{data.gstin} - {data.legal_name}</CDropdownItem>)
                  })}

                </CDropdownMenu>}

              </CDropdown>
            </div>
          </CHeaderNavItem>
        </CHeaderNav>
        <CHeaderNav className="d-md-down-none ml-auto">
           <CHeaderNavItem className="px-1  top-header-dropdown-menu">
            <CHeaderNavLink to="/dashboard" className="text-dark font-size-12 text-uppercase">Dashboard</CHeaderNavLink>
          </CHeaderNavItem>
          <CHeaderNavItem className="px-1  top-header-dropdown-menu">
            <CHeaderNavLink to="/gstr-2a" className="text-dark font-size-12 text-uppercase">GSTR-2A</CHeaderNavLink>
          </CHeaderNavItem>
          <CHeaderNavItem className="px-1  top-header-dropdown-menu">
            <CHeaderNavLink to="/gstr-2b" className="text-dark font-size-12 text-uppercase">GSTR-2B</CHeaderNavLink>
          </CHeaderNavItem>
          <CHeaderNavItem className="px-1  top-header-dropdown-menu">
            <CHeaderNavLink to="/new-purchase-register" className="text-dark font-size-12 text-uppercase">Purchase Register</CHeaderNavLink>
          </CHeaderNavItem>
          <CHeaderNavItem className="px-1  top-header-dropdown-menu">
            <CHeaderNavLink to="/supplier" className="text-dark font-size-12 text-uppercase">Suppliers</CHeaderNavLink>
          </CHeaderNavItem>
          <CDropdown variant="nav-item">
            <CDropdownToggle className="header-dropdown-menu shadow-none" color="secondary" size="sm">REPORTS</CDropdownToggle>
            <CDropdownMenu className="border-0 shadow-sm">
              <CDropdownItem to="/matched-report" className="font-size-12 status-font">Matched </CDropdownItem>
              <CDropdownItem to="/misMatch-report" className="font-size-12 status-font">Mismatch</CDropdownItem>
              <CDropdownItem to="/MissingIn2A-report" className="font-size-12 status-font">Missing in 2A</CDropdownItem>
              <CDropdownItem to="/MissingIn2B-report" className="font-size-12 status-font">Missing in 2B</CDropdownItem>
              <CDropdownItem to="/MissingInBooks-report" className="font-size-12 status-font">Missing in Books</CDropdownItem>
              <CDropdownItem to="/ProbableMatch-report" className="font-size-12 status-font"> Probable Match</CDropdownItem>
            </CDropdownMenu>
          </CDropdown>

          <CHeaderNavItem className="px-1  top-header-dropdown-menu">
            <CHeaderNavLink to="/new-reconciliation" className="text-dark font-size-12 status-font text-uppercase">Reconciliation</CHeaderNavLink>
          </CHeaderNavItem>
        </CHeaderNav>
        <CHeaderNav className="pr-2 mr-2 mobile-pad-right-0 mobile-margin-right-0">
          <TheHeaderDropdown />
        </CHeaderNav>
      </CHeader> */}

      {/* new navigation bar */}
      <nav className="navbar navbar-expand-lg navbar-light bg-white">
        <a className="navbar-brand pl-2" href="#">
          <img src={theme === "dark" ? whitelogo : logo} className="c-sidebar-brand-full d-none d-xl-block logo" />
          <img src={theme === "dark" ? whiteFav : fav} className="c-sidebar-brand-minimized d-xl-none logo" />
        </a>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon">
            <i className="fas fa-bars"></i>
          </span>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav mr-auto">
            {/* <CHeaderNavItem className="px- p-0 company-bg-background top-header-dropdown-menu">
              <div className="d-flex">
              <div class="dropdown">
                <button type="button" class="gst-pan-btn btn btn-dark  dropdown-toggle status-font shadow-none btn-sm font-size-12" data-toggle="dropdown">
                  GSTIN
                </button>
                <div class="dropdown-menu" style={{width:"140px"}}>
                  <a class="dropdown-item font-size-12 status-font" href="#">GSTIN</a>
                  <a class="dropdown-item font-size-12 status-font" href="#">PAN</a>
                  
                </div>
              </div>
                <CDropdown className="mt-0 pan-gst-border">
                  <CDropdownToggle caret={false} color="link btn-sm text-dark bold-label" style={{ fontSize: "10px", boxShadow: 'none', lineHeight: '1.5', textDecoration: 'none', paddingLeft: 0, fontWeight: "600", textTransform: "capitalize" }}>
                    <Tooltip title="Change GSTIN" placement={'right-end'} arrow>
                      <div>
                        <div className="main-company">{cookie.load("SELECTED_GSTIN_DETAIL") ? <>{cookie.load("SELECTED_GSTIN_DETAIL").gstin} - {cookie.load("SELECTED_GSTIN_DETAIL").legal_name}</> : <>{dropDownValue.gstin} - {dropDownValue.legal_name}</>}</div>
                        <i className="fas fa-chevron-circle-down min-font-size ml-2"></i>
                      </div>
                    </Tooltip>
                  </CDropdownToggle>


                  {cookie.load('SELECTED_GSTIN_LIST') !== undefined && <CDropdownMenu className="border-0 mdb-shadow small-font-dropdown slideIn animate-dropdown" >
                    {cookie.load('SELECTED_GSTIN_LIST').length > 0 && cookie.load('SELECTED_GSTIN_LIST').map((data, i) => {
                      return (<CDropdownItem key={i} onClick={() => onDropDownChange(data)}>{data.gstin} - {data.legal_name}</CDropdownItem>)
                    })}

                  </CDropdownMenu>}

                </CDropdown>
              </div>
            </CHeaderNavItem> */}
            <CHeaderNavItem className="px-3 company-bg-background top-header-dropdown-menu">
              <div>
                <CDropdown className="mt-0">
                  <CDropdownToggle caret={false} color="link btn-sm text-dark bold-label" style={{ fontSize: "10px", boxShadow: 'none', lineHeight: '1.4', textDecoration: 'none', paddingLeft: 0, fontWeight: "600", textTransform: "capitalize" }}>
                    <Tooltip title="Change GSTIN" placement={'right-end'} arrow>
                      <div>
                        <div className="main-company">{cookie.load("SELECTED_GSTIN_DETAIL") ? <>{cookie.load("SELECTED_GSTIN_DETAIL").gstin} - {cookie.load("SELECTED_GSTIN_DETAIL").legal_name}</> : <>{dropDownValue.gstin} - {dropDownValue.legal_name}</>}</div>
                        <i className="fas fa-chevron-circle-down min-font-size ml-2"></i>
                      </div>
                    </Tooltip>
                  </CDropdownToggle>
                  {selectedGstnList !== undefined && <CDropdownMenu className="border-0 mdb-shadow small-font-dropdown slideIn animate-dropdown" style={{maxHeight:"250px", overflow:"auto"}}>
                    {selectedGstnList.length > 0 && selectedGstnList.map((data, i) => {
                      return (<CDropdownItem key={i} onClick={() => onDropDownChange(data)}>{data.gstin} - {data.legal_name}</CDropdownItem>)
                    })}

                  </CDropdownMenu>}

                </CDropdown>
              </div>
            </CHeaderNavItem>
          </ul>
          <ul className="navbar-nav ml-auto">
            <CHeaderNavItem className="top-header-dropdown-menu px-2">
              <CHeaderNavLink to="/dashboard" className="text-dark font-size-10 bold-label text-uppercase">Dashboard</CHeaderNavLink>
            </CHeaderNavItem>
            <CHeaderNavItem className="top-header-dropdown-menu px-2">
              <CHeaderNavLink to="/gstr-2a" className="text-dark font-size-10 bold-label text-uppercase">GSTR-2A</CHeaderNavLink>
            </CHeaderNavItem>
            <CHeaderNavItem className="top-header-dropdown-menu px-2">
              <CHeaderNavLink to="/gstr-2b" className="text-dark font-size-10 bold-label text-uppercase">GSTR-2B</CHeaderNavLink>
            </CHeaderNavItem>
            <CHeaderNavItem className="top-header-dropdown-menu px-2">
              <CHeaderNavLink to="/new-purchase-register" className="text-dark bold-label font-size-10 text-uppercase">Purchase Register</CHeaderNavLink>
            </CHeaderNavItem>
            <CHeaderNavItem className="top-header-dropdown-menu px-2">
              <CHeaderNavLink to="/supplier" className="text-dark font-size-10 bold-label text-uppercase">Suppliers</CHeaderNavLink>
            </CHeaderNavItem>
            <CDropdown variant="nav-item">
              <CDropdownToggle className="text-dark header-dropdown-menu shadow-none bold-label" size="sm">REPORTS</CDropdownToggle>
              <CDropdownMenu className="border-0 shadow-sm">
                <CDropdownItem to="/all-report" className="font-size-12 bold-label normal-demo-text status-font">All Reports </CDropdownItem>
                <CDropdownItem to="/matched-report" className="font-size-12 bold-label normal-demo-text status-font">Matched </CDropdownItem>
                <CDropdownItem to="/misMatch-report" className="font-size-12 bold-label normal-demo-text status-font">Mismatch</CDropdownItem>
                <CDropdownItem to="/MissingIn2A-report" className="font-size-12 bold-label normal-demo-text status-font">Missing in 2A</CDropdownItem>
                <CDropdownItem to="/MissingIn2B-report" className="font-size-12 bold-label normal-demo-text status-font">Missing in 2B</CDropdownItem>
                <CDropdownItem to="/MissingInBooks-report" className="font-size-12 bold-label normal-demo-text status-font">Missing in Books</CDropdownItem>
                <CDropdownItem to="/ProbableMatch-report" className="font-size-12 bold-label normal-demo-text status-font"> Probable Match</CDropdownItem>

                <CDropdownItem to="/ManualMatch-report" className="font-size-12 bold-label normal-demo-text status-font"> Manual Match</CDropdownItem>

              </CDropdownMenu>
            </CDropdown>

            <CHeaderNavItem className="top-header-dropdown-menu px-2">
              <CHeaderNavLink to="/new-reconciliation" className="text-dark font-size-10 bold-label status-font text-uppercase">Manual Reco.</CHeaderNavLink>
            </CHeaderNavItem>
            <CHeaderNavItem className="px-2">
              <CHeaderNavLink className="text-dark" onClick={() => setprimaryRefModal(true)}><Tooltip title="Switch to Tally On The Go" arrow><i className="fas fa-th" style={{ fontSize: "16px", lineHeight: 1.5 }}></i></Tooltip></CHeaderNavLink>
            </CHeaderNavItem>

          </ul>
          <ul className="navbar-nav pr-0 mr-3 mobile-pad-right-0 mobile-margin-right-0">
            <TheHeaderDropdown />
          </ul>

        </div>
      </nav>
      {/* new navigation bar ends */}
      <div className="header-dropdown-pop-inside  profile-modal right-animation right-5-percent">
        <CModal
          show={primaryRefModal}
          centered
          size="lg"
          onClose={() => onRefModalClose()}
          color="dark right"
        // closeOnBackdrop={false}
        >

          <CModalBody className="text-left less-modal-bold p-4">
            <div className="row">
              <div className="col-md-4">
                <h6 className="text-dark font-size-14 bold-label mb-0 mt-1">Switch to</h6>
              </div>
              <div className="col-md-8 text-right">
                <button className="btn text-dark btn-link font-size-12 bold-label btn-xs" onClick={() => setprimaryRefModal(false)}><i className="fa fa-times"></i></button>
              </div>
            </div>
            <div className="mt-3">
              <span><img src={FIcon} className="switch-icon-gst" /></span>
              <span><button className="btn btn-link text-primary shadow-none btn-25-radius bold-label" onClick={redirectToGST}>TALLY ON THE GO <i className="fas fa-external-link-alt"></i></button></span>
            </div>
          </CModalBody>
        </CModal>
      </div>
    </>
  );
};

export default TheHeader;